import { Box, Grid, styled } from '@mui/material';

export const LogMessageContainer = styled(Grid)(() => ({
  wordBreak: 'break-all'
}));

export const LogRequestsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

export const LogRequestDetailsContainer = styled(Grid)(({ theme }) => ({
  alignItems: 'stretch',
  '& .MuiGrid-item': {
    padding: theme.spacing(1)
  },
  '& .MuiCard-root': {
    height: '100%',
    paddingBlock: theme.spacing(2),
    paddingInline: theme.spacing(3)
  }
}));
